// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/notam-item-format.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/notam-item-format/notam-item-format.js';

mount([g0]);
